module.exports = __webpack_public_path__ + "img/01_sp.cb4d65b1.jpg";